/**
 * Suggested questions for the AI Assistant by current page (pathname).
 * Shown as chips so the user can tap and send without typing.
 */

export interface SuggestedQuestion {
  label: string;
  message: string;
}

const BY_PATH: Record<string, SuggestedQuestion[]> = {
  '/': [
    { label: 'How is the composite score calculated?', message: 'How is the SAA composite score and grade calculated?' },
    { label: 'What is data quality tier?', message: 'What does data quality tier LIVE_VERIFIED vs ESTIMATED mean?' },
    { label: 'What metrics are used for rating?', message: 'What metrics does SAA use for asset rating?' },
  ],
  '/dashboard': [
    { label: 'How is the composite score calculated?', message: 'How is the SAA composite score and grade calculated?' },
    { label: 'What is data quality tier?', message: 'What does data quality tier LIVE_VERIFIED vs ESTIMATED mean?' },
  ],
  '/reports': [
    { label: 'How is the report generated?', message: 'How is the institutional report generated? What is the pipeline?' },
    { label: 'What is the QA gate?', message: 'What is the QA gate and when is export blocked?' },
    { label: 'What are HF001–HF018?', message: 'What are the HF001–HF018 quality gates?' },
  ],
  '/alerts': [
    { label: 'How do alert subscriptions work?', message: 'How do alert subscriptions and threshold breaches work?' },
    { label: 'What triggers a breach?', message: 'What triggers a threshold breach and how am I notified?' },
  ],
  '/agent': [
    { label: 'What is the report team pipeline?', message: 'What is the report team pipeline and which agents run?' },
    { label: 'What does OversightAgent do?', message: 'What does OversightAgent do and when is a report blocked?' },
    { label: 'What is request_id?', message: 'What is request_id in the agent pipeline and where is it used?' },
  ],
  '/assistant': [
    { label: 'What can you help with?', message: 'What can you help me with on this platform?' },
    { label: 'Regulatory basis for US status?', message: 'What is the regulatory basis for US status?' },
    { label: 'How is report summary generated?', message: 'How is the AI report summary generated?' },
  ],
  '/portfolio': [
    { label: 'What is BTC co-movement?', message: 'What is the BTC co-movement score and how is it calculated (correlation + R²)?' },
    { label: 'How is correlation with BTC used?', message: 'How is correlation with BTC calculated and what does it mean for diversification?' },
  ],
  '/scenario': [
    { label: 'What scenarios can I run?', message: 'What scenarios can I run and what do they simulate?' },
  ],
};

const DEFAULT_SUGGESTIONS: SuggestedQuestion[] = [
  { label: 'What is the regulatory basis for US status?', message: 'What is the regulatory basis for US status in the methodology?' },
  { label: 'How is the report generated?', message: 'How is the institutional report generated?' },
  { label: 'What is data quality tier?', message: 'What does data quality tier mean?' },
];

/**
 * Returns suggested questions for the given pathname (e.g. /compliance, /reports).
 * Normalizes path (strip trailing slash, use / for root).
 */
export function getSuggestionsForPath(pathname: string): SuggestedQuestion[] {
  const path = pathname.replace(/\/$/, '') || '/';
  return BY_PATH[path] ?? DEFAULT_SUGGESTIONS;
}
